import Vue from "vue";
import Vuex from "vuex";
import cloneDeep from 'lodash.clonedeep'
import throttle from 'lodash.throttle';
import draft from "./draft";
import msg from "./msg";

Vue.use(Vuex);

function writrFile(dataVal) {
  if (process.env.NODE_ENV != "development") {
    api.writeFile(
      {
        path: "cache://chatList.json",
        data: JSON.stringify(dataVal)
      },
      function(ret, err) {
        if (ret.status) {
          //成功
          // console.log("写入成功")
        } else {
          // console.log("写入失败")
        }
      }
    );
  }
}
// 如果你用 HMR（热重载），可以这样防止多次声明：
if (!window._cfList) window._cfList = [];
if (!window._cfListInTemplate) window._cfListInTemplate = [];

let _cfList = window._cfList;
let _cfListInTemplate = window._cfListInTemplate;

let store = new Vuex.Store({
  // strict: true,
  state: {
    chatList: [],
    medicineList: [],
    herbList: [],
    foodList: [],
    groupsList: [],
    showLoading: false,
    historyUrl: "",
    keep_alive: [],
    groupsInfo: {},
    fsendgroupsList: [],
    searchHistory: [],
    topicList: [],
    checkList: [],
    lisList: [],
    herbArr: [],
    docShStatus: -1,
    themeColor: "#FF5050",
    cfTypeList:[],
    // 新增,判断当前是cfTemplate，代码中则将数据转到处方模版的新字段中。在导入处方或存为模版中，双方再互相赋值
    cfTemplate: false,
    // 处方锁，能否修改处方，在页面初加载赋值时，锁住，加载完放开
    cfLock: false,
    get cfList() {
      return this.cfTemplate ? _cfListInTemplate : _cfList;
    },
    set cfList(val) {
      if(this.cfLock) return;
      if (this.cfTemplate) {
        _cfListInTemplate = val;
      } else {
        _cfList = val;
      }
    },
    cfParams: {}, // 抽屉开处方参数
    // 
    forceUpdateobj: {
      popup: false,
      iosUrl: "",
      android: ""
    },
    isLogin: 0,
    txLogined: false, // 是否登录
    curRegId: '', // 当前接诊id
    grabCard: '', // 是否是抢单卡片进来的
    needUpdateStatusMap: [{
      groupId: '',
      regIdList: [],
      onlineStatusDesc: '离线',
      onlineStatus: 'offline'
    }], // 需要更新状态的消息列表
  },
  getters: {
    getTxLogined(state) {
      return state.txLogined;
    },
    getIsLogin(state) {
      return state.isLogin;
    },
    getChatList(state) {
      return state.chatList;
    },
    getOneChatList: state => {
      return chatId => state.chatList.find(item => item.id == chatId);
    },
    getMedicineList(state) {
      return state.medicineList;
    },
    getHerbList(state) {
      return state.herbList;
    },
    getShowLoading(state) {
      return state.showLoading;
    },
    getForceupdate(state) {
      return state.forceUpdateobj;
    },
    getHistoryUrl(state) {
      return state.historyUrl;
    },
    getKeepAlive(state) {
      return state.keep_alive;
    },
    getGroupsList(state) {
      return state.groupsList;
    },
    getFsendGroupsList(state) {
      return state.fsendgroupsList;
    },
    getGroupsInfo(state) {
      return state.groupsInfo;
    },
    getSearchHistory(state) {
      return state.searchHistory;
    },
    getTopicList(state) {
      return state.topicList;
    },
    getCfTypeList(state) {
      return state.cfTypeList;
    },
    getCheckList(state) {
      return state.checkList;
    },
    getLisList(state) {
      return state.lisList;
    },
    getHerbArr(state) {
      return state.herbArr;
    },
    getDocShStatus(state) {
      return state.docShStatus;
    },
    getThemeColor(state) {
      return state.themeColor;
    },
    getCfTemplate(state) {
      return state.cfTemplate;
    },
    getCfTemplateId(state) {
      // 如果是处方模版，则返回处方模版的id，否则返回0，这个只会在导入时用到
      return state.cfList[0] && state.cfList[0].templateId || 0;
    },
    getCfTemplateCode(state) {
      // 如果是处方模版，则返回处方模版的code，否则返回''，这个只会在新接口导入时用到
      return state.cfList[0] && state.cfList[0].templateCode || '';
    },
    getCfTemplateType(state) {
      // 如果是处方模版，则返回处方模版的处方模版类型，否则返回0，这个只会在新接口导入时用到
      return state.cfList[0] && state.cfList[0].templateType || 0;
    },
    getCfLock(state) {
      return state.cfLock;
    },
    getCfList(state) {
      // 数据隔离
      return cloneDeep(state.cfList);
    },
    getCfParams(state) {
      return state.cfParams;
    },
    getFoodList(state) {
      return state.foodList;
    },
    getCurRegId(state) {
      return state.curRegId;
    },
    getGrabCard(state) {
      return state.grabCard;
    },
    getNeedUpdateStatusMap(state) {
      return state.needUpdateStatusMap;
    }
  },
  mutations: {
    __VUEX_MY_PERSISTEDSTATE_SET__(state, { key, value }) {
      state[key] = value;
    },
    setTxLogined(state, value) {
      state.txLogined = value;
    },
    setIsLogin(state, value) {
      state.isLogin = value
    },
    setCfTemplate(state, value) {
      state.cfTemplate = value
    },
    setCfLock(state, value) {
      state.cfLock = value
    },
    setCfList(state, value) {
      if(state.cfLock) return;
      // 新增一个 cf
      const list = state.cfList.slice();
      list.push(value);
      state.cfList = list; // 触发 setter
    },
    setAllCfList(state, value) {
      if(state.cfLock) return;
      state.cfList = value; // 触发 setter
    },
    editCf(state, value) {
      if(state.cfLock) return;
      const list = state.cfList.slice();
      list.splice(value.cfIndex, 1, value.cf);
      state.cfList = list;
    },
    switchCf(state, value) {
      if(state.cfLock) return;
      const list = state.cfList.slice();
      let item = list[value.cfIndex];
      item.type = value.type;
      item.name = value.name;
      item.drugList = [];
      list.splice(value.cfIndex, 1, item);
      state.cfList = list;
    },
    setDrugOne(state, value) {
      if(state.cfLock) return;
      const list = state.cfList.slice();
      if(!list[value.cfIndex]) return;
      if (value.type == "edit") {
        list[value.cfIndex].drugList.splice(value.index, 1, value.drugVal);
      } else {
        list[value.cfIndex].drugList.push(value.drugVal);
      }
      state.cfList = list;
    },
    deleteDrug(state, value) {
      if(state.cfLock) return;
      const list = state.cfList.slice();
      list[value.cfIndex].drugList.splice(value.index, 1);
      state.cfList = list;
    },
    deleteCf(state, value) {
      if(state.cfLock) return;
      const list = state.cfList.slice();
      if (value == 0 && list.length == 1) {
        list[value].drugList.splice(0, list[value].drugList.length);
      } else {
        list.splice(value, 1);
      }
      state.cfList = list;
    },
    setCfParams(state, value) {
      state.cfParams = value;
    },
    setThemeColor(state, value) {
      state.themeColor = value;
    },
    setCfTypeList(state, value) {
      state.cfTypeList = value;
    },
    setTopicList(state, value) {
      state.topicList.push(value);
    },
    setTopicListOne(state, value) {
      state.topicList[value.index] = value.item;
      state.topicList = Object.assign([], state.topicList);
    },
    setAllTopic(state, value) {
      state.topicList = Object.assign([], value);
    },
    setsearchHistory(state, payload) {
      state.searchHistory.unshift(payload);
    },
    clearAllHistory(state, payload) {
      state.searchHistory = [];
    },
    setEmptyList(state, value) {
      let id = value.patientId.toLowerCase() + "," + value.docId.toLowerCase();
      let arr = [];
      if (state.chatList.length > 0) {
        state.chatList.map(item => {
          arr.push(item.id);
        });
      }

      if (arr.indexOf(id) == -1 || state.chatList.length == 0) {
        state.chatList.push({
          id: id,
          chatRecordList: [],
          top: false
        });
      }

      console.log(JSON.stringify(id) + "setEmptyList =============");
      console.log(
        JSON.stringify(arr.indexOf(id)) + "setEmptyList ============="
      );
      // console.log(JSON.stringify(state.chatList) + "--------list");
      api.sendEvent({
        name: "jzPatient"
      });
      state.chatList = Object.assign([], state.chatList);
      writrFile(state.chatList);
    },
    setChatList(state, payload) {
      let status = "sending";
      console.log(JSON.stringify(payload) + "--------payload");
      // 医生接诊后  欢迎语后端发送的type默认是receive  唯一标识是ext的flag为1   手动改成type = send
      if (payload.ext && payload.ext.flag && payload.ext.flag == 1) {
        payload.type = 'send'
      }
      if (payload.ext && payload.ext.flag && payload.ext.flag == 2) {  // 问诊卡信息
        const parsedDiseaseImg = typeof payload.ext.diseaseImg == 'string' ? JSON.parse(payload.ext.diseaseImg) : payload.ext.diseaseImg;
        payload.ext.fileUrlList = parsedDiseaseImg
      }
      console.log(JSON.stringify(payload) + "--------payload333");
      if (payload.type == "receive") {
        if (AppVue.$route.query && AppVue.$route.query.id) {
          var id = AppVue.$route.query.id
            ? AppVue.$route.query.id.toLowerCase()
            : "";

          console.log(id + "-----------" + payload.ext.patientId.toLowerCase());
          if (id == payload.ext.patientId.toLowerCase()) {
            status = "read";
          }
        } else {
          status = payload.status;
        }
        if (payload.from != "admin") {
          var id =
            payload.ext.patientId.toLowerCase() +
            "," +
            payload.to.toLowerCase(); //患者id加医生id
        } else {
          var id = payload.from.toLowerCase() + "," + payload.to.toLowerCase(); //患者id加医生id
        }
      } else {
        var id =
          payload.ext.patientId.toLowerCase() +
          "," +
          payload.from.toLowerCase();
        if (!status) {
          status = "sending";
        }
      }
      if (!payload.status) {
        payload.status = status;
      }
      //如果是第一次发消息 则直接存储
      let idList = [];
      state.chatList.map(item => {
        idList.push(item.id);
      });
      if (idList.length == 0) {
        state.chatList.push({
          chatRecordList: [payload],
          id: id,
          time: payload.time
        });
        api.sendEvent({
          name: "jzPatient"
        });
      } else {
        if (idList.indexOf(id) == -1) {
          state.chatList.push({
            chatRecordList: [payload],
            id: id,
            time: payload.time
          });
        } else {
          let index = idList.indexOf(id);
          state.chatList[index].chatRecordList.push(payload);
          state.chatList[index].time = payload.time;
        }
      }
      state.chatList = Object.assign([], state.chatList);
      writrFile(state.chatList);
    },
    updateMessageStatus(state, message) {
      let name;
      if (
        AppVue.$route.query.id &&
        message.toId == AppVue.$route.query.id.toLowerCase()
      ) {
        name =
          AppVue.$route.query.id.toLowerCase() +
          "," +
          message.from.toLowerCase();
      } else if (message.toId) {
        name = message.toId.toLowerCase() + "," + message.from.toLowerCase();
      }
      let id = message.id || message.mid;
      console.log(id + "--------------id-------" + name);
      state.chatList.map((item, index) => {
        if (name == item.id) {
          let list = item.chatRecordList;
          list.map((el, elIndex) => {
            if (el.mid == id) {
              if (el.status != "recall") {
                el.status = message.status;
                el.mid = message.mid;
                el.conversationId = message.conversationId?message.conversationId:el.conversationId;
                if (message.content) {
                  el.content = message.content;
                }
              }
            }
          });
        }
      });
      state.chatList = Object.assign([], state.chatList);
      writrFile(state.chatList);
    },
    updateCardStatus(state, message) {
      let name = message.chatId;
      state.chatList.map((item, index) => {
        if (name == item.id) {
          let list = item.chatRecordList;
          list.map((el, elIndex) => {
            if (el.mid == message.mid) {
              el = message;
            }
          });
        }
      });
      state.chatList = Object.assign([], state.chatList);
      writrFile(state.chatList);
    },

    setIndexChatList(state, value) {
      state.chatList.map((item, index) => {
        if (value.chatId == item.id) {
          let list = item.chatRecordList;
          list.map((el, elIndex) => {
            if (elIndex == value.index) {
              el = value.item;
            }
          });
        }
      });
      state.chatList = Object.assign([], state.chatList);
      writrFile(state.chatList);
    },
    setOneChatList(state, value) {
      let list;
      if (JSON.stringify(this.state.chatList).indexOf(value.chatId) == -1) {
        state.chatList.push({
          id: value.chatId,
          chatRecordList: value.chatRecordList,
        })
      } else {
        if (state.chatList.length == 0) {
          state.chatList.push({
            id: value.chatId,
            chatRecordList: value.chatRecordList
          });
        } else {
          state.chatList.map((item, index) => {
            if (value.chatId == item.id) {
              list = item.chatRecordList
              if ((value.chatRecordList[0].time && list[0].time >= value.chatRecordList[0].time) || value.chatRecordList.length == 0) {
                item.chatRecordList = value.chatRecordList
              } else {
                let s = false
                let m = item.chatRecordList.length - 1
                for (; m >= 0; m--) {
                  let el = list[m]
                  let val = value.chatRecordList[0]
                  if (val.time > el.time) {
                    let arr = list.slice(0, m + 1)
                    arr = arr.concat(value.chatRecordList)
                    item.chatRecordList = arr
                    break
                  }
                }
              }
            }
          });
        }
      }
      state.chatList = Object.assign([], state.chatList);
      writrFile(state.chatList);
    },
    setItemChatList(state, value) {
      state.chatList[value.id] = value.item;
      state.chatList = Object.assign([], state.chatList);
      writrFile(state.chatList);
    },
    setAllChatList(state, value) {
      state.chatList = Object.assign([], value);
      writrFile(state.chatList);
    },
    setMedicineList(state, value) {
      state.medicineList = value;
    },
    setHerbList(state, value) {
      state.herbList = value;
    },
    setFoodList(state, value) {
      state.foodList = value;
    },
    setHerbArr(state, value) {
      state.herbArr = value;
    },
    // setShowLoading(state, value) {
    //   state.showLoading = value;
    // },
    setForceupdate(state, value) {
      state.forceUpdateobj = value;
    },
    setHistoryUrl(state, value) {
      state.historyUrl = value;
    },
    setGroupsList(state, value) {
      state.groupsList = value;
    },
    setGroupList(state, value) {
      state.fsendgroupsList = value;
    },
    setGroupsInfo(state, value) {
      state.groupsInfo = value;
    },
    setDocShStatus(state, value) {
      console.log("sssss------------审核状态" + state.docShStatus);
      state.docShStatus = value;
    },
    setCheckList(state, value) {
      let list = state.checkList;
      list.push(value);
      state.checkList = Object.assign([], list);
      console.log(state.checkList, "state.checkList");
    },
    setAllCheckList(state, value) {
      state.checkList = Object.assign([], value);
    },
    setLisList(state, value) {
      let list = state.lisList;
      list.push(value);
      state.lisList = Object.assign([], list);
      console.log(state.lisList, "state.lisList");
    },
    setAllLisList(state, value) {
      state.lisList = Object.assign([], value);
    },
    UPDATE_KEEP_ALIVE(state, payload) {
      //当payload.type不为空则代表清除指定缓存组件，否则添加指定组件
      if (payload.type) {
        let index = state.keep_alive.indexOf(payload.keepAlive);
        if (index !== -1) {
          state.keep_alive.splice(index, 1); //删除数组的缓存的组件
        }
      } else {
        let index = state.keep_alive.indexOf(payload.keepAlive);
        if (index === -1) {
          state.keep_alive.push(payload.keepAlive); //添加需要缓存的组件
        }
      }
    },
    setCurRegId(state, value) {
      state.curRegId = value;
    },
    setGrabCard(state, value) {
      state.grabCard = value;
    },
    setNeedUpdateStatusMap(state, payload) {
      state.needUpdateStatusMap = payload;
    }
  },
  modules: {
    draft,
    msg
  },
  plugins: [
    vuexMyPersistedState({
      name: 'myvuex',
      mutationMap: {
        'draft/setSummary': ['draft.summary'],
        'draft/setElectron': ['draft.electron'],
        'draft/removeElectron': ['draft.electron'],
        'draft/SET_PATIENT_TAB': ['draft.patientTab'],
        'msg/UPDATE_SOUND_CONFIG': ['msg.soundConfig'],
        'setCurRegId': ['curRegId'],
        'setGrabCard': ['grabCard'],
      },
    })
  ],
});

function vuexMyPersistedState(options = {}) {
  const spacename = options.name || 'myvuex'; // 命名空间
  // 新的配置格式：明确指定每个 mutation 影响的字段
  const mutationMap = options.mutationMap || {};

  // 写入 localStorage
  const saveState = (dataToSave = {}) => {
    const oldData = JSON.parse(window.localStorage.getItem(spacename) || '{"data":{}}').data || {};
    window.localStorage.setItem(spacename, JSON.stringify({ data: { ...oldData, ...dataToSave } }));
  };

  // 支持 draft.xj 这种路径
  function getValueByPath(state, path) {
    return path.split('.').reduce((acc, cur) => acc && acc[cur], state);
  }

  return store => {
    // 收集所有需要初始化的 paths
    const allPaths = [...new Set(Object.values(mutationMap).flat())];
    // 1. 初始化时从 localStorage 加载指定字段
    allPaths.forEach(key => {
      const saved = JSON.parse(window.localStorage.getItem(spacename)||'{"data":{}}')?.data?.[key];
      if (typeof saved !== 'undefined' && saved !== false && saved !== null) {
        if (key.includes('.')) {
          const [module, field] = key.split('.');
          store.commit(`${module}/__VUEX_MY_PERSISTEDSTATE_SET__`, { key: field, value: saved });
        } else {
          store.commit('__VUEX_MY_PERSISTEDSTATE_SET__', { key, value: saved });
        }
      }
    });

    // 2. 只监听部分 mutation，自动保存指定字段
    store.subscribe((mutation, state) => {
      const relatedPaths = mutationMap[mutation.type];
      if (relatedPaths) {
        const dataToSave = {};
        relatedPaths.forEach(path => {
          const value = path.includes('.') ? getValueByPath(state, path) : state[path];
          if (value !== undefined) {
            dataToSave[path] = value;
          }
        });
        if (Object.keys(dataToSave).length > 0) {
          saveState(dataToSave);
        }
      }
    });
  };
}

export default store;
